const µ = 3.986004418 * 10 ** 14;
const d_bas_twopi = Math.PI * 2.0;
export const meanMotionFromSMA = (a) => Math.sqrt(µ / a ** 3);
function orb_elevec(a, e, i, Ω, w, v) {
    let d_p = a * ((1.0 + e) * (1.0 - e));
    d_p = Math.max(d_p, 1e-30);
    const d_f = Math.sqrt(µ / d_p);
    const d_cv = Math.cos(v);
    const d_ecv = 1.0 + e * d_cv;
    const d_r = d_p / d_ecv;
    const d_u = w + v;
    const d_cu = Math.cos(d_u);
    const d_su = Math.sin(d_u);
    const d_co = Math.cos(Ω);
    const d_so = Math.sin(Ω);
    const d_ci = Math.cos(i);
    const d_si = Math.sin(i);
    const d_cocu = d_co * d_cu;
    const d_sosu = d_so * d_su;
    const d_socu = d_so * d_cu;
    const d_cosu = d_co * d_su;
    const d_fx = d_cocu - d_sosu * d_ci;
    const d_fy = d_socu + d_cosu * d_ci;
    const d_fz = d_su * d_si;
    const d_vr = d_f * e * Math.sin(v);
    const d_vu = d_f * d_ecv;
    const x = d_r * d_fx;
    const y = d_r * d_fy;
    const z = d_r * d_fz;
    const vx = d_vr * d_fx - d_vu * (d_cosu + d_socu * d_ci);
    const vy = d_vr * d_fy - d_vu * (d_sosu - d_cocu * d_ci);
    const vz = d_vr * d_fz + d_vu * d_cu * d_si;
    return { x, y, z, vx, vy, vz };
}
function orb_anomaly(e, M) {
    let d_eccanom_ini = M;
    let d_eccanom = M + e * Math.sin(d_eccanom_ini);
    let maxIter = 50;
    let j = 0;
    while (Math.abs(d_eccanom - d_eccanom_ini) > 1.0e-5 && j < maxIter) {
        d_eccanom_ini = d_eccanom;
        d_eccanom = M + e * Math.sin(d_eccanom_ini);
        j++;
    }
    const d_bas_twopi = Math.PI * 2.0;
    d_eccanom = d_eccanom % d_bas_twopi;
    let d_trueanom = 2.0 *
        Math.atan2(Math.sqrt(1.0 + e) * Math.sin(d_eccanom / 2.0), Math.sqrt(1.0 - e) * Math.cos(d_eccanom / 2.0));
    d_trueanom = (d_trueanom + d_bas_twopi) % d_bas_twopi;
    return d_trueanom;
}
export function orb2sv(a, e, i, ω, Ω, M_0, t_0, t) {
    const d_t = t - t_0;
    const M = M_0 + d_t * Math.sqrt(µ / a ** 3);
    const v = orb_anomaly(e, M);
    return orb_elevec(a, e, i, Ω, ω, v);
}
export function sv2orb(x, y, z, vx, vy, vz) {
    let d_poe_xmu = µ;
    const C1 = y * vz - z * vy;
    const C2 = z * vx - x * vz;
    const C3 = x * vy - y * vx;
    const CC12 = C1 * C1 + C2 * C2;
    const CC = CC12 + C3 * C3;
    const C = Math.sqrt(CC);
    const V02 = vx ** 2 + vy ** 2 + vz ** 2;
    const R0V0 = x * vx + y * vy + z * vz;
    const R02 = x ** 2 + y ** 2 + z ** 2;
    const R0 = Math.sqrt(R02);
    const X = (R0 * V02) / d_poe_xmu;
    const CX = CC / d_poe_xmu;
    const STE = (R0V0 * C) / (R0 * d_poe_xmu);
    const CTE = CX / R0 - 1.0;
    const a = R0 / (2.0 - X);
    const e = Math.sqrt(STE * STE + CTE * CTE);
    const i = Math.atan2(Math.sqrt(CC12), C3);
    let Ω;
    let U;
    if (CC12 > CC * 1e-16) {
        U = Math.atan2(C * z, y * C1 - x * C2);
        Ω = Math.atan2(C1, -C2);
    }
    else {
        U = Math.atan2(y, x) * Math.sign(C3);
        Ω = 0.0;
    }
    let ω;
    let v;
    if (e > 1e-16) {
        v = Math.atan2(STE, CTE);
        ω = U - v;
    }
    else {
        v = U;
        ω = 0.0;
    }
    Ω = (Ω + d_bas_twopi) % d_bas_twopi;
    ω = (ω + d_bas_twopi) % d_bas_twopi;
    v = (v + d_bas_twopi) % d_bas_twopi;
    const M = true_meanAnom(e, v);
    return { a, i, e, M, ω, Ω };
}
function true_meanAnom(e, v) {
    let tmp = 1.0 + e;
    let d_eccanom = 2.0 *
        Math.atan2(Math.sqrt(2.0 - tmp) * Math.sin(v / 2.0), Math.sqrt(tmp) * Math.cos(v / 2.0));
    d_eccanom = (d_eccanom + d_bas_twopi) % d_bas_twopi;
    let d_meanom = d_eccanom - e * Math.sin(d_eccanom);
    d_meanom = (d_meanom + d_bas_twopi) % d_bas_twopi;
    return d_meanom;
}
//# sourceMappingURL=propagation.js.map